import clsx from 'clsx';
import CrossIcon from '@images/svg-icons/crossIcon.svg';
import { useEffect, useRef } from 'react';

interface Props {
    isOpen: boolean;
    close: () => void;
    children: any;
    showCloseIcon?: boolean;
    isCentered?: boolean;
    insertAnalytics?: boolean;
    shorter?: boolean;
}

const Modal = ({
    isOpen,
    close,
    children,
    showCloseIcon = true,
    isCentered = true,
    insertAnalytics = false,
}: Props): JSX.Element => {
    const modalRef = useRef(null);

    const ModalBody = (): JSX.Element => {
        return (
            <>
                <div className="background-layer" onClick={close}></div>

                <div
                    className={clsx('modal-container', isCentered && 'modal--centred')}
                    ref={modalRef}
                >
                    <div className="modal-content">
                        {showCloseIcon && (
                            <button
                                aria-label="Close button"
                                className="icon-container"
                                onClick={close}
                            >
                                <CrossIcon />
                            </button>
                        )}
                        {children}
                    </div>
                </div>
            </>
        );
    };

    useEffect(() => {
        // Enable / disable the page body scroll lock when the modal is open / closed
        document
            .querySelectorAll('html, body')
            .forEach((e: HTMLElement) => (e.style.overflowY = !!isOpen ? 'hidden' : ''));
    }, [isOpen]);

    return (
        isOpen &&
        (insertAnalytics ? (
            <div data-analytics_available_call="0">
                <ModalBody />
            </div>
        ) : (
            <ModalBody />
        ))
    );
};
export default Modal;
